import type React from 'react';

import { RotationLeftIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';

import { useResetConfirmationTranslation } from './i18n';
import st from './ResetConfirmation.module.sass';

interface ResetConfirmationProps {
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

function ResetConfirmation({
  onConfirm,
  onReject,
}: ResetConfirmationProps): React.JSX.Element {
  const { t } = useResetConfirmationTranslation();
  return (
    <div className={st.Root}>
      <RotationLeftIcon className={st.Icon} />
      <div className={st.IconAndText}>
        <div className={st.Body}>
          <h5>{t('title')}</h5>
          <p>{t('description')}</p>
        </div>
      </div>
      <div className={st.Actions}>
        <Button
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('reject')}
        </Button>
        <Button
          kind="negative"
          onClick={onConfirm}
          variant="filled"
        >
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
}

export { ResetConfirmation };
